<template>
  <modal name="missing-case-data-modal" :width="500">
    <form @submit.prevent="saveMissingData">
      <button type="button" class="modal-close" @click="$modal.hide('missing-case-data-modal')">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5999 1.40002L7.9999 8.00002M1.3999 14.6L7.9999 8.00002M7.9999 8.00002L1.3999 1.40002M7.9999 8.00002L14.5999 14.6"
            :stroke="$color"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
      <h3 class="modal-title">CO Z MOJĄ SPRAWĄ?</h3>
      <h4 class="modal-subtitle">Podaj {{ missingDataTitle }}</h4>
      <div class="field">
        <input type="text" class="input" v-model="missingData" />
        <button type="submit" class="arrow">
          <svg
            width="24"
            height="18"
            viewBox="0 0 24 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.3415 0.247437C15.7571 -0.116245 16.3889 -0.0741276 16.7526 0.341509L23.7526 8.34151C24.0825 8.71853 24.0825 9.28149 23.7526 9.65852L16.7526 17.6585C16.3889 18.0742 15.7571 18.1163 15.3415 17.7526C14.9259 17.3889 14.8837 16.7571 15.2474 16.3415L20.7962 10H1C0.447715 10 0 9.5523 0 9.00001C0 8.44773 0.447715 8.00001 1 8.00001H20.7962L15.2474 1.65852C14.8837 1.24288 14.9259 0.611119 15.3415 0.247437Z"
              :fill="$color"
            />
          </svg>
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
// This component is in case the user is not authorized, but still needs to send a request
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  data: () => ({
    name: "MissingDataModal",
    missingDataTitle: '',
    missingData: null,
    missingDataSetter: () => {},
  }),
  props: {
    bus: Object,
  },
  computed: {
    ...mapState(['userData', 'userName'])
  },
  methods: {
    ...mapMutations(['setUserData', 'setUserName', 'setNumber', 'setActivePage']),
    ...mapActions(['getPesel', 'getClaimData']),


    attemptSendUserQuestion() {
      // TODO attempt to get missing data from API

      if (!this.userData.PhoneNumber) {
        this.promptMissingData('numer telefonu', PhoneNumber => this.setUserData({PhoneNumber}));
      } else if (!this.userName) {
        this.promptMissingData('imię i nazwisko', this.setUserName);
      } else {
        this.$modal.hide('missing-case-data-modal');
        // TODO check if there's any doubles of this logic (case_steps/Result.vue)
        this.getPesel()
          .then((res) => {
            if (res.data.Successful) {
              this.setActivePage("caseResultSuccess"); // TODO move this success to a different component
            } else {
              this.setActivePage("caseNoResult");
            }
            this.number = "";
          })
          .catch((err) => {
            this.setActivePage("caseNoResult");
            this.number = "";
          });
      }
    },
    promptMissingData(name, setter) {
      this.missingDataTitle = name;
      this.missingDataSetter = setter;
      this.$modal.show("missing-case-data-modal");
    },
    saveMissingData() {
      this.missingDataSetter(this.missingData);
      this.missingDataTitle = this.missingDataSetter = this.missingData = null;
      this.attemptSendUserQuestion();
    }
  },
  mounted() {
    this.bus.$on('attemptSendUserQuestion', this.attemptSendUserQuestion)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/MissingDataModal.vue